export default __webpack_public_path__ + "static/media/admin.e96f2490.jpg";